(function () {
    'use strict';

    const initFeatureTwoCols = () => {
        const sections = document.querySelectorAll(
            '.feature-banners-twocolumn'
        );

        if (!sections.length) {
            return;
        }

        const isMobile = window.matchMedia(
            '(max-width: 1024px)'
        ).matches;

        sections.forEach((section) => {
            const mediaBlocks = section.querySelectorAll(
                '.feature-banners-twocolumn__media'
            );

            mediaBlocks.forEach((mediaBlock) => {
                const picture =
                    mediaBlock.querySelector('picture');

                const videoWrapper =
                    mediaBlock.querySelector(
                        '.feature-banners-twocolumn__media__video'
                    );

                const video =
                    mediaBlock.querySelector('video');

                if (!videoWrapper || !video) {
                    console.log('Missing element');
                    return;
                }

                let videoLoaded = false;

                const loadVideo = () => {
                    if (videoLoaded) {
                        return;
                    }

                    const isMobileVideo = window.innerWidth <= 767;

                    const videoSrc = isMobileVideo
                        ? (video.dataset.mobileSrc || video.dataset.desktopSrc)
                        : video.dataset.desktopSrc;

                    if (!videoSrc) {
                        return;
                    }

                    video.src = videoSrc;
                    video.load();

                    videoLoaded = true;
                };

                // Lazy Load Observer
                const lazyLoadObserver =
                    new IntersectionObserver(
                        (entries, observer) => {
                            entries.forEach((entry) => {
                                if (
                                    entry.isIntersecting
                                ) {
                                    loadVideo();
                                    observer.unobserve(
                                        entry.target
                                    );
                                }
                            });
                        },
                        {
                            rootMargin: '100px'
                        }
                    );

                lazyLoadObserver.observe(mediaBlock);

                // Initial State
                if (picture) {
                    picture.style.display = 'block';
                }

                videoWrapper.style.display = 'none';

                const showVideo = () => {
                    loadVideo();

                    if (picture) {
                        picture.style.display =
                            'none';
                    }

                    videoWrapper.style.display =
                        'block';

                    video.currentTime = 0;

                    const playPromise =
                        video.play();

                    if (
                        playPromise !== undefined
                    ) {
                        playPromise.catch(
                            (err) => {
                                console.error(
                                    'Video play failed:',
                                    err
                                );
                            }
                        );
                    }
                };

                const showImage = () => {
                    video.pause();
                    video.currentTime = 0;

                    videoWrapper.style.display =
                        'none';

                    if (picture) {
                        picture.style.display =
                            'block';
                    }
                };

                if (!isMobile) {
                    mediaBlock.addEventListener(
                        'mouseenter',
                        showVideo
                    );

                    mediaBlock.addEventListener(
                        'mouseleave',
                        showImage
                    );
                } else {
                    const observer =
                        new IntersectionObserver(
                            (entries) => {
                                entries.forEach(
                                    (entry) => {
                                        if (
                                            entry.isIntersecting
                                        ) {
                                            showVideo();
                                        } else {
                                            showImage();
                                        }
                                    }
                                );
                            },
                            {
                                threshold: 0.2
                            }
                        );

                    observer.observe(
                        mediaBlock
                    );
                }
            });
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            initFeatureTwoCols
        );
    } else {
        initFeatureTwoCols();
    }
})();